var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDatabase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 44,
    viewBox: "0 0 41 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 15.0526V22C41 27.7547 31.8206 32.4211 20.5 32.4211C9.17944 32.4211 0 27.7547 0 22V15.0526C0 20.8074 9.17944 25.4737 20.5 25.4737C31.8206 25.4737 41 20.8074 41 15.0526ZM0 26.6316C0 32.3863 9.17944 37.0526 20.5 37.0526C31.8206 37.0526 41 32.3863 41 26.6316V33.5789C41 39.3337 31.8206 44 20.5 44C9.17944 44 0 39.3337 0 33.5789V26.6316ZM20.5 20.8421C9.17944 20.8421 0 16.1758 0 10.4211C0 4.66632 9.17944 0 20.5 0C31.8206 0 41 4.66632 41 10.4211C41 16.1758 31.8206 20.8421 20.5 20.8421Z",
    fill: "#F94F01"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/database.106b6340.svg";
export { ForwardRef as ReactComponent };